import Http from '../api/http/';

export default class CompanyArea extends Http {
  constructor() {
    super();
  }
  /***********企业区域***************/
  /**
   * 删除
   * @param {string} id -  id
   */
  companyArea_delete() {
    return super.post('companyArea/delete', ...arguments);
  }
  /**
   * 查询集合（下拉）
   * @param {string} companyId -  companyId
   */
  companyArea_getList() {
    return super.post('companyArea/getList', ...arguments);
  }

  /**
   * 分页查询
   * @param {string} areaName -  areaName
   * @param {integer} rows -  rows
   * @param {integer} page -  page
   * @param {string} companyId -  companyId
   */
  companyArea_getListByPage() {
    return super.post('companyArea/getListByPage', ...arguments);
  }

  /**
   * 修改企业区域
   * @param {Array} companyAreaDto -  companyAreaDto
   */
  companyArea_update() {
    return super.post('companyArea/update', ...arguments);
  }

  /**
   * 批量导入区域
   * @param file
   * @param companyId
   */
  companyArea_importExcel() {
    return super.post('companyArea/importExcel', ...arguments);
  }
  /**
   * 区域树结构
   * @returns
   */
  companyArea_getCompanyAreaTreeVo() {
    return super.post('companyArea/getCompanyAreaTreeVo', ...arguments);
  }

  /**
   * 关联门店
   * @returns
   */
  companyArea_relateAreaAndStore() {
    return super.post('companyArea/relateAreaAndStore', ...arguments);
  }

  /**
   * 区域下拉
   * @returns
   */
  companyArea_getCompanyAreaList() {
    return super.post('companyArea/getCompanyAreaList', ...arguments);
  }
  // 导入修改区域模板下载
  companyArea_exportAreaExcel() {
    return super.get('companyArea/exportAreaExcel', ...arguments);
  }

  /**
   * 区域树联动列表查询
   * @param {string} areaId -  选中的区域Id
   * @param {string} companyId -  企业Id
   * @param {integer} rows -  行数
   * @param {integer} page -  页数
   */
  companyArea_getAreaListForTreeNode() {
    return super.post('companyArea/getAreaListForTreeNode', ...arguments);
  }

  /**
   * 批量取消关联
   * @param {Array} areaIds -  areaIds
   */
  companyArea_relateAreaAndStoreBatch() {
    return super.post('companyArea/relateAreaAndStoreBatch', ...arguments);
  }
  /**
   * *根据企业id获取企业区域数据
   * @param {string} companyId -  企业Id
   */
  companyArea_getCompanyAreaInfos() {
    return super.post('companyArea/getCompanyAreaInfos', ...arguments);
  }
  /**
   * 批量导入区域
   * @param excelFile -  文件
   * @param {string} companyId -  企业Id
   */
  companyArea_importAreaInfos() {
    return super.post('companyArea/importAreaInfos', ...arguments);
  }
  /**
   * 拖动区域排序
   * @param {string} companyId -  企业Id
   * @param {object} nodes -  当前层级的所有数据
   */
  companyArea_moveNodeInSameLevel() {
    return super.post('companyArea/moveNodeInSameLevel', ...arguments);
  }
}
